/**
 * CH-6 (29-sep-2026): lo que ha terminado mientras el autor hacía otra cosa —un informe, una pasada,
 * una maquetación—, con un botón para ir a verlo. Antes solo se enteraba si volvía a esa pantalla.
 */
import { mostrarEnCarpeta, type Trabajo } from "../api";
import { avisoDeTrabajo } from "../logica";

export default function Terminados({ lista, seccion, irA, cerrar }: {
  lista: Trabajo[]; seccion: string; irA: (id: string) => void; cerrar: (id: string) => void;
}) {
  const preguntar = typeof Notification !== "undefined" && Notification.permission === "default";
  return (
    <>
      {lista.map((t) => {
        const a = avisoDeTrabajo(t);
        return (
          <div className={`trabajo-hecho ${a.clase}`} key={t.id} role="status">
            <p>{a.texto}</p>
            <div className="botones">
              {a.destino && a.destino !== seccion && (
                <button className="btn texto" onClick={() => { irA(a.destino!); cerrar(t.id); }}>Verlo</button>
              )}
              {/* Lo que no tiene pantalla propia (un encargo que propuso el coach) está en la carpeta del libro. */}
              {a.ruta && (
                <button className="btn texto" onClick={() => { mostrarEnCarpeta(a.ruta!).catch(() => {}); }}>Enseñar en la carpeta</button>
              )}
              {preguntar && (
                <button className="btn texto" title="Si el Studio está en otra pestaña, te avisa el sistema"
                        onClick={() => { Notification.requestPermission().catch(() => {}); }}>Avisarme también en otra pestaña</button>
              )}
              <button className="btn texto" onClick={() => cerrar(t.id)}>Cerrar</button>
            </div>
          </div>
        );
      })}
    </>
  );
}
